export const VENDOR_DETAIL_OFFERS_MAX_PAGE_SIZE = 30;
